import {SummaryScreen} from "../screens";
import {useDispatch, useSelector} from "react-redux";
import {apiUrl} from "../misc/actions";
import {useNavigate} from "react-router-dom";
import {Routes} from "../utils";
import {useState} from "react";
import {clearStore} from "../store/mainSlice";


export default function SummaryContainer(props) {
    const store = useSelector(({main}) => ({
        dimensions: main.dimensions,
        config: main.config,
        customerDetails: main.customerDetails,
    }))
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [error, setError] = useState(null)
    const [sending, setSending] = useState(false)

    const handleSubmit = () => {
        const payload = {
            config: {
                ...store.config,
                color: store.config.color.value,
                product: store.config.product.value,
            },
            firstname: store.customerDetails.firstname,
            lastname: store.customerDetails.lastname,
            postcode: store.customerDetails.postcode,
            city: store.customerDetails.city,
            address: store.customerDetails.address,
            phone: store.customerDetails.phone,
            email: store.customerDetails.email,
            message: store.customerDetails.message,
            product_id: store.config.product.value,
            color: store.config.color.value,
            width: store.dimensions.width,
            height: store.dimensions.height,
        }



        setSending(true)
        setError(null)
        fetch(
            `${apiUrl}/order/add`,
            {
                method: 'post',
                body: JSON.stringify(payload),
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                }
            },
        )
            .then(r => r.json())
            .then(res => {
                if(res.status === 'success') {
                    dispatch(clearStore())
                    window.location.href = Routes.orderFinalized
                } else {
                    setError(res)
                }
            })
            .catch(err => {
                console.error('error!', err)
            })
            .finally(() => {
                setSending(false)
            })
    }

    return (
        <SummaryScreen
            error={error}
            sending={sending}
            onSubmit={handleSubmit}
        />
    )
}
